import SystemPerformance from './SystemPerformance'
export default SystemPerformance
